import MetaHeader from '../components/common/MetaHeader';
import ALink from '../components/common/ALink';

export default function ReturnReplacements() {
  return (
    <>
    <MetaHeader title={'Returns Replacements'}/>
    <main className="main">
      <nav aria-label="breadcrumb" className="breadcrumb-nav mb-0">
        <div className="container">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <ALink href="/">Home</ALink>
            </li>
            <li className="breadcrumb-item">
              <ALink href="#">Pages</ALink>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Returns & Replacements
            </li>
          </ol>
        </div>
      </nav>

      <div className="container">
        <div className="subpage">
          <h1 className="subpage__title">Returns</h1>
          <p className="subpage__paragraph">
            Please reach out to a BuyOnTrust representative to discuss your return options, as well as required policies
            and procedures. Customers are required to make a full and complete return. Customers may be subject to
            rental fees and/or restocking fees, as well as bear the full cost and liability for shipping the items back.
            Each individual item may come with a different return policy and procedure. Customers are financially
            responsible for the cost of shipping and for the items during shipment. BuyOnTrust does not authorize any
            cash or equivalent refund to customers, including but not limited to credit cards, debit cards, cash cards,
            in-store credit, or bank accounts. All items must be returned in full and undamaged. Damaged merchandise is
            non-returnable, and the sale is final.
          </p>
          <p className="subpage__paragraph">
            Failure to abide by these terms violates the terms of our agreement and may halt any further actions by
            BuyOnTrust. BuyOnTrust does not guarantee any lease adjustments based on returns, refunds, sales, or any
            other promotions. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at
            its discretion. Returns may be subject to the manufacturer, lease provider, or any other applicable
            entities. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease
            provider for many final decisions.
          </p>
          <p className="subpage__paragraph">
            Customers can and are encouraged to speak with their lease provider regarding any financial matters,
            including returns, especially when their item is outside of the return window. In many cases, no returns are
            allowed after 72 hours from the date and time of delivery as reported by the courier.
          </p>
          <div className="subpage__section">
            <h2 className="subpage__list-title">
              Returns Process
            </h2>
          </div>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              To start a return, customers are required to do the following within 72 hours of the date and time the
              item(s) were delivered:
            </p>
          </div>
          <div className="subpage__section">
            <p className="subpage__paragraph bolder">
              Customers are required to email:
              <a
                  href="mailto:info@buyontrust.com"
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                info@buyontrust.com
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Subject line:
              <a
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                Return
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Explain in the body of the email:
            </p>
            <ul className="subpage__list">
              <li>
                If the item(s) were damaged in transit, customers must provide pictures of all sides of the original
                packaging, unopened, showing any signs of damage.
              </li>
              <li>Regardless of whether items are damaged or not, customers must provide pictures of all items from all
                sides.
              </li>
              <li>
                List of item(s) being returned (Include SKUs and quantities of each SKU).
              </li>
              <li>Reason(s) for the return.</li>
              <li>
                Are you requesting replacements or removal of the item(s) from your lease?
              </li>
            </ul>
          </div>

          <p className="subpage__paragraph">
            Please allow 1-3 business days for initial responses from the BuyOnTrust Quality Assurance team.
          </p>
          <p className="subpage__paragraph">
            Additional costs might be incurred by returning and/or replacing any item(s), and many lease providers require a minimum dollar value to be maintained on a lease. This means you may be required to return all items on your lease or maintain a higher dollar value on your lease than was previously agreed to. Also, this could result in rental fees. By speaking with BuyOnTrust first, we can help you make an informed decision.
          </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with top-quality customer service. Customers are financially responsible for all items during pending investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or rental fees may be applicable.
          </p>
        </div>
        <div className="subpage">
          <h1 className="subpage__title">Replacement</h1>
          <div className="subpage__section">
            <p className="subpage__paragraph">
              No exchanges. Replacements may be allowed but must be for the same item, with the same SKU, and require no changes to the lease. Replacements are at BuyOnTrust’s discretion.
            </p>
          </div>
          <div className="subpage__section">
            <p className="subpage__paragraph bolder">
              Customers are required to email:
              <a
                  href="mailto:info@buyontrust.com"
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                info@buyontrust.com
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Subject line:
              <a
                  style={{
                    marginLeft: '4px',
                    color: '#4f4f4f',
                    fontWeight: '600'
                  }}>
                Replacement
              </a>
            </p>
            <p className="subpage__paragraph bolder">
              Explain the reason/s for wanting a replacement.
            </p>
          </div>

          <p className="subpage__paragraph italic">
            Additional costs might be incurred by replacing any item(s), and many lease providers require a minimum dollar value to be maintained on a lease. This means you may be required to return all items on your lease or maintain a higher dollar value on your lease than was previously agreed to. Also, this could result in rental fees. By speaking with BuyOnTrust first, we can help you make an informed decision.
          </p>
          <p className="subpage__paragraph">
            Please also note that customers might be required to sign an updated lease before items can be changed on their order. Changes are not guaranteed. Please allow 1-3 business days for initial responses from the BuyOnTrust Quality Assurance team.
          </p>
          <p className="subpage__paragraph">
            BuyOnTrust appreciates your business, patience, and cooperation as we work to provide our customers with top-quality customer service. Customers are financially responsible for all items during pending investigations. BuyOnTrust reserves the right to issue, and/or not issue, refunds or lease adjustments at its discretion. Your financial obligations are also to your lease provider. BuyOnTrust yields to the lease provider for many final decisions. Customers are encouraged to speak with their lease provider regarding any financial matters, especially when their item is no longer returnable to the retail store. Restocking and/or rental fees may be applicable.
          </p>
        </div>
      </div>
    </main>
    </>
  );
}
